/* global Swiper */

/**
 * The JavaScript code you place here will be processed by esbuild, and the
 * output file will be created at `../theme/js/script.min.js` and enqueued in
 * `../theme/functions.php`.
 *
 * For esbuild documentation, please see:
 * https://esbuild.github.io/
 */

import masonryGrid from './js/old/masonryGrid';

masonryGrid();

// add a variable for getting the scrollbar width
document.documentElement.style.setProperty( '--scrollbar-width', `${window.innerWidth - document.documentElement.clientWidth  }px` );
